export const SET_QUOTES = "SET_QUOTES";

export const ADD_QUOTE = "ADD_QUOTE";
